import axios from "axios";
import { API_DOMAIN } from "../../../constants";

export function authHeaders() {
  return { headers: { accessToken: localStorage.getItem("accessToken") } };
}

export function apiGet(path) {
  return axios.get(`${API_DOMAIN}${path}`, authHeaders());
}

export function apiPost(path, payload = {}, config = {}) {
  return axios.post(`${API_DOMAIN}${path}`, payload, { ...authHeaders(), ...config });
}

export function apiPut(path, payload = {}) {
  return axios.put(`${API_DOMAIN}${path}`, payload, authHeaders());
}

export function apiPatch(path, payload = {}) {
  return axios.patch(`${API_DOMAIN}${path}`, payload, authHeaders());
}

export function apiDelete(path, payload) {
  const { headers } = authHeaders();
  return axios.delete(`${API_DOMAIN}${path}`, { headers, data: payload });
}
